<template>
  <button
    v-bind="$attrs"
    class="btn btn-primary"
    :class="{ loading: loading }"
    :disabled="loading"
    @click.stop
  >
    <span class="button-text">{{ text }}</span>
  </button>
</template>

<script setup lang="ts">
import { withDefaults, defineProps } from "vue";

export interface Props {
  loading?: boolean
  text?: string
}
const props = withDefaults(defineProps<Props>(), {
  text: 'Opal',
});

</script>

<style lang="scss" scoped>
.btn {
  position: relative;

  &.loading {
    &::after {
      content: "";
      position: absolute;
      width: 16px;
      height: 16px;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      border: 4px solid transparent;
      border-top-color: #ffffff;
      border-radius: 50%;
      animation: button-loading-spinner 1s ease infinite;
    }

    .button-text {
      visibility: hidden;
      opacity: 0;
    }
  }
}

.cuscd-dark .btn.loading::after {
  border-top-color: #000100;
}
/* Small and Medium devices (phones, tablets, 992px and down) */
@media (max-width: 992px) {
  .btn {
    font-size: 1em;
    max-width: calc(50% - 5px);
    min-width: 140px;

    .button-text {
      font-size: 1.1em;
    }
  }
}
@keyframes button-loading-spinner {
  from {
    transform: rotate(0turn);
  }

  to {
    transform: rotate(1turn);
  }
}
</style>
